// assets
import {
    IconMessageCircle,
    IconGraph,
    IconCalendar,
    IconSettings,
    IconClipboardData,
    IconBrandZoom,
    IconCoin,
    IconMessages,
    IconRobot,
    IconDashboard,
    IconBrandFramer,
    IconTypography,
    IconPalette,
    IconShadow,
    IconWindmill,
    IconLayoutGridAdd,
    IconUser,
    IconUsers,
    IconBuilding,
    IconEdit,
    IconUserSearch,
    IconUserPlus,
    IconTicket,
    IconArrowGuide,
    IconSpeakerphone,
    IconFilter,
    IconArrowsRightLeft,
    IconFileDots,
    IconBuildingStore,
    IconAddressBook,
    IconHome,
    IconTemplate,
    IconFolder,
    IconListDetails,
    IconBriefcase,
    IconSend
} from '@tabler/icons';

import { IconSparkles } from '@tabler/icons-react';

// constant
const icons = {
    IconUserPlus: IconUserPlus,
    IconUserSearch: IconUserSearch,
    IconEdit: IconEdit,
    IconBuilding: IconBuilding,
    IconUser: IconUser,
    IconUsers: IconUsers,
    IconTicket: IconTicket,
    IconMessageCircle: IconMessageCircle,
    IconGraph: IconGraph,
    IconCalendar: IconCalendar,
    IconSettings: IconSettings,
    IconClipboardData: IconClipboardData,
    IconBrandZoom: IconBrandZoom,
    IconCoin: IconCoin,
    IconMessages: IconMessages,
    IconRobot: IconRobot,
    IconDashboard: IconDashboard,
    IconTypography: IconTypography,
    IconPalette: IconPalette,
    IconShadow: IconShadow,
    IconWindmill: IconWindmill,
    IconBrandFramer: IconBrandFramer,
    IconLayoutGridAdd: IconLayoutGridAdd,
    IconArrowGuide: IconArrowGuide,
    IconSpeakerphone: IconSpeakerphone,
    IconFilter: IconFilter,
    IconArrowsRightLeft: IconArrowsRightLeft,
    IconFileDots: IconFileDots,
    IconBuildingStore: IconBuildingStore,
    IconAddressBook: IconAddressBook,
    IconSparkles: IconSparkles,
    IconHome: IconHome,
    IconTemplate: IconTemplate,
    IconFolder: IconFolder,
    IconListDetails: IconListDetails,
    IconBriefcase: IconBriefcase,
    IconSend: IconSend
};

//-----------------------|| UTILITIES MENU ITEMS ||-----------------------//

export const utilities = {
    id: 'utilities',
    title: 'Painel',
    type: 'group',
    children: [
        {
            id: 'util-Leads',
            title: 'Negócios',
            type: 'item',
            url: '/dashboard/config/pipeline',
            icon: icons['IconFilter'],
            breadcrumbs: false,
            beta: false
        },
        {
            id: 'util-typography',
            title: 'Conversas',
            type: 'item',
            url: '/dashboard/chats',
            icon: icons['IconMessageCircle'],
            breadcrumbs: false,
            beta: false
        },
        {
            id: 'util-vendas',
            title: 'Vendas',
            type: 'item',
            url: '/dashboard/orders',
            icon: icons['IconCoin'],
            breadcrumbs: false,
            beta: false
        },
        {
            id: 'util-contacts',
            title: 'Contatos',
            type: 'item',
            url: '/dashboard/contacts',
            icon: icons['IconAddressBook'],
            breadcrumbs: false,
            beta: false
        },
        {
            id: 'util-produtos-servicos',
            title: 'Produtos/Serviços',
            type: 'item',
            url: '/dashboard/config/catalog',
            icon: icons['IconBuildingStore'],
            requiresFlag: 'catalog',
            breadcrumbs: false,
            beta: false
        },
        {
            id: 'util-imoveis',
            title: 'Imóveis',
            type: 'item',
            url: '/dashboard/config/imoveis',
            icon: icons['IconHome'],
            requiresModule: 'imobiliaria',
            breadcrumbs: false,
            beta: false
        },
        {
            id: 'util-contratos-servico',
            title: 'Contratos',
            type: 'item',
            url: '/dashboard/config/services',
            icon: icons['IconBriefcase'],
            requiresFlag: 'services',
            breadcrumbs: false,
            beta: false
        },
        {
            id: 'util-Flows-home',
            title: 'Chatbots',
            type: 'item',
            url: '/dashboard/config/chatbots',
            icon: icons['IconRobot'],
            breadcrumbs: false,
            beta: false
        },
        {
            id: 'util-calendario',
            title: 'Agenda',
            type: 'item',
            url: '/dashboard/config/calendar',
            icon: icons['IconCalendar'],
            breadcrumbs: false,
            beta: false
        },
        {
            id: 'settings-users',
            title: 'Clientes',
            type: 'collapse',
            icon: icons['IconUsers'],
            children: [
                {
                    id: 'settings-users-view',
                    title: 'Ver Clientes',
                    type: 'item',
                    icon: icons['IconUserSearch'],
                    url: '/dashboard/config/users/view',
                    breadcrumbs: false,
                    beta: false
                },
                {
                    id: 'settings-users-add',
                    title: 'Criar Cliente',
                    type: 'item',
                    icon: icons['IconUserPlus'],
                    url: '/dashboard/config/users/create',
                    breadcrumbs: false,
                    beta: false
                }
            ]
        },
        {
            id: 'settings-organizations',
            title: 'Empresas',
            type: 'collapse',
            icon: icons['IconBuilding'],
            children: [
                {
                    id: 'settings-organizations-view',
                    title: 'Ver Empresa',
                    type: 'item',
                    icon: icons['IconBuilding'],
                    url: '/dashboard/config/organizations/view',
                    breadcrumbs: false,
                    beta: false
                },
                {
                    id: 'settings-organizations-add',
                    title: 'Criar Empresa',
                    type: 'item',
                    icon: icons['IconEdit'],
                    url: '/dashboard/config/organizations/create',
                    breadcrumbs: false,
                    beta: false
                }
            ]
        },
        {
            id: 'util-envio-documentos',
            title: 'Envio de Documentos',
            type: 'item',
            icon: icons['IconSend'],
            url: '/dashboard/config/organizations/envio-documentos',
            breadcrumbs: false,
            beta: false
        },
        {
            id: 'util-Agentes',
            title: 'Agentes',
            type: 'item',
            url: '/dashboard/config/agents/view',
            icon: icons['IconRobot'],
            breadcrumbs: false,
            beta: false
        },
        //? {
        //?     id: 'util-financeiro',
        //?     title: 'Financeiro (2 via)',
        //?     type: 'item',
        //?     url: '/dashboard/config/agents/view',
        //?     icon: icons['IconRobot'],
        //?     breadcrumbs: false
        //? },
        //? {
        //?     id: 'util-templates',
        //?     title: 'Templates',
        //?     type: 'item',
        //?     url: '/dashboard/config/agents/view',
        //?     icon: icons['IconRobot'],
        //?     breadcrumbs: false
        //? },
        {
            id: 'util-Disparos',
            title: 'Disparos',
            type: 'item',
            url: '/dashboard/config/shots',
            icon: icons['IconSpeakerphone'],
            breadcrumbs: false,
            beta: false
        },
        {
            id: 'util-marketing',
            title: 'Marketing',
            type: 'item',
            url: '/dashboard/marketing',
            icon: icons['IconBrandZoom'],
            breadcrumbs: false,
            beta: false
        },
        {
            id: 'util-documentos',
            title: 'Documentos',
            type: 'item',
            url: '/dashboard/config/documentos',
            icon: icons['IconFolder'],
            breadcrumbs: false,
            beta: false
        },
        {
            id: 'util-whatsapp-templates',
            title: 'Templates WhatsApp',
            type: 'item',
            url: '/dashboard/config/whatsapp_templates',
            icon: icons['IconTemplate'],
            breadcrumbs: false,
            beta: false
        },
        {
            id: 'util-whatsapp-interactive',
            title: 'Botões e Listas WhatsApp',
            type: 'item',
            url: '/dashboard/config/whatsapp_interactive',
            icon: icons['IconListDetails'],
            breadcrumbs: false,
            beta: false
        },

        // {
        //     id: 'util-relatorios',
        //     title: 'Relatórios',
        //     type: 'item',
        //     url: '/utils/util-report',
        //     icon: icons['IconClipboardData'],
        //     breadcrumbs: false,
        //     beta: true
        // },
        {
            id: 'util-automacao',
            title: 'Automação',
            type: 'item',
            url: '/dashboard/admin/automation',
            icon: icons['IconRobot'],
            breadcrumbs: false,
            beta: false
        },
        {
            id: 'util-dashboard',
            title: 'Dashboard',
            type: 'item',
            url: '/dashboard/panel/',
            icon: icons['IconDashboard'],
            breadcrumbs: false,
            beta: false
        },
        {
            id: 'util-resumo',
            title: 'Resumo',
            type: 'item',
            url: '/dashboard/resumo/',
            icon: icons['IconSparkles'],
            breadcrumbs: false,
            beta: false
        },
        // {
        //     id: 'util-docs',
        //     title: 'Documentação',
        //     type: 'item',
        //     url: '/dashboard/docs/welcome',
        //     icon: icons['IconFileDots'],
        //     breadcrumbs: false,
        //     beta: false
        // },
        {
            id: 'util-Tickets',
            title: 'Tickets',
            type: 'item',
            url: '/dashboard/config/tickets',
            icon: icons['IconTicket'],
            breadcrumbs: false,
            beta: false
        }
    ]
};
